import TagManager from 'react-gtm-module';

const tagManagerArgs = {
  gtmId: import.meta.env.VITE_GTM_ID,
};

const isProduction = import.meta.env.MODE === 'production';
const enableTagManager = import.meta.env.VITE_ENABLE_GTM === 'true';

export function initTagManager() {
  if (isProduction && enableTagManager) {
    TagManager.initialize(tagManagerArgs);
  }
}
